import { cn } from '@/shared/lib'

type Props = {
  className?: string
  progress: number
}

export const ProgressBar = ({ className, progress }: Props) => {
  return (
    <div
      className={cn('absolute top-0 left-0 h-1 w-full bg-gray-100', className)}
    >
      <div className="h-full bg-purple-500" style={{ width: `${progress}%` }} />
    </div>
  )
}
